import forEach from 'lodash/forEach';
import isPlainObject from 'lodash/isPlainObject';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';

/**
 * Transforms an object:
 * { my: { nested: { object: 'foo' } } }
 * 
 * to flatten object:
 * { 'my.nested.object': 'foo' }
 * 
 * @param {Object} obj
 */
export const flattenObject = (obj) => {
    const result = {};

    const flatten = (collection, prefix = '') => {
        forEach(collection, (value, key) => {
            const path = `${prefix}${key}`;

            if (isPlainObject(value)) {
                flatten(value, `${path}.`);
            } else if (isArray(value) && value.every(nestedValue => !isString(nestedValue))) {
                forEach(value, (nestedValue, index) => {
                    flatten(nestedValue, `${path}[${index}].`);
                })
            } else {
                result[path] = value;
            }
        });
    };

    flatten(obj);

    return result;
};

export const uuid = () => {
    return 'xxxx-xxxx'.replace(/[x]/g, (c) => {
        let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const maskNumber = (evt) => {
    evt = evt ? evt : window.event;
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
    ) {
        evt.preventDefault();
    } else {
        return true;
    }
};
